export default "__VITE_ASSET__DF_T21Pa__"